(() => {
  const config = document.querySelector('script[data-hadrill-trio-fallback]');
  if (!config || window.hadrillTrioLinksReady) return;
  window.hadrillTrioLinksReady = true;
  const target = new URL(config.dataset.hadrillTrioFallback, location.origin);
  const hosts = new Set([location.host, 'hadrillhair.com.au', 'www.hadrillhair.com.au']);
  function update(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.hasAttribute('href')) return;
    if (anchor.closest('.cart-form, .cart-items__wrapper, [data-preserve-product-link]')) return;
    let url;
    try { url = new URL(anchor.getAttribute('href'), location.href); } catch { return; }
    if (!['http:', 'https:'].includes(url.protocol) || !hosts.has(url.host)) return;
    const parts = url.pathname.split('/').filter(Boolean);
    const direct = parts.length === 2 && parts[0] === 'products' && parts[1] === 'the-trio';
    const collection = parts.length === 4 && parts[0] === 'collections' && parts[2] === 'products' && parts[3] === 'the-trio';
    if (!direct && !collection) return;
    url.pathname = target.pathname;
    url.searchParams.delete('variant');
    url.origin === location.origin ? anchor.setAttribute('href', url.pathname + url.search + url.hash) : anchor.setAttribute('href', target.origin + url.pathname + url.search + url.hash);
    if (anchor.textContent.trim() === 'Ritual Signature Trio') anchor.textContent = 'Ritual Trio (unboxed)';
  }
  function scan(root) {
    if (root instanceof HTMLAnchorElement) update(root);
    root.querySelectorAll?.('a[href]').forEach(update);
  }
  scan(document);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
    }
  });
  observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['href']});
  for (const type of ['pointerdown', 'focusin', 'click']) document.addEventListener(type, event => {
    const anchor = event.composedPath().find(node => node instanceof HTMLAnchorElement);
    if (anchor) update(anchor);
  }, true);
})();

